var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5654 1.00697C19.832 0.363781 17.9572 0.0117188 16 0.0117188C14.0429 0.0117188 12.1682 0.363781 10.4349 1.00684L9.73926 16.0117L10.4349 31.0166C12.1682 31.6597 14.0429 32.0117 16 32.0117C17.9573 32.0117 19.832 31.6597 21.5654 31.0165L22.261 16.0117L21.5654 1.00697Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0117C0 22.8911 4.342 28.7558 10.4348 31.0165V1.00684C4.342 3.26759 0 9.13221 0 16.0117Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0117C32 9.13221 27.658 3.26759 21.5652 1.00684V31.0165C27.658 28.7558 32 22.8911 32 16.0117Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGuinea);
export default __webpack_public_path__ + "static/media/flag_guinea.7f85e6e239d16073423621cdde22a55d.svg";
export { ForwardRef as ReactComponent };